/** Compact weather badge with emoji icon + temperature */
import { weatherConditionInfo } from '@/lib/weather';
import { useI18n } from '@/context/I18nContext';

interface WeatherBadgeProps {
  condition: string;
  temperatureC: number;
  trackCondition?: string;
}

export function WeatherBadge({ condition, temperatureC, trackCondition }: WeatherBadgeProps) {
  const { t } = useI18n();
  const cond = weatherConditionInfo(condition, t);

  return (
    <span className="inline-flex items-center gap-1 text-[0.7rem]">
      <span>{cond.icon}</span>
      <span className="mono text-text-primary">{temperatureC}°C</span>
      {trackCondition && (
        <span className="text-text-muted">· {trackCondition}</span>
      )}
    </span>
  );
}
